import { Component } from 'preact'
import Modal, {
  ModalBody,
  ModalHeader
  // eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/design-system-components/modal'
import { WidgetCard } from './WidgetCard'
import { WidgetCategoryFilter } from './WidgetCategoryFilter'
// eslint-disable-next-line import/no-internal-modules
import { common } from '@insided/deprecated-preact-components/common'
import { LIBRARY_WIDGETS_METADATA, LIBRARY_WIDGET_CATEGORIES, WidgetContainerType } from '@insided/customization'

export interface WidgetsModalProps {
  onClose: () => void
  onWidgetSelected: (selectedWidgetType: string) => void
  containerComponent: WidgetContainerType
}

interface WidgetsModalState {
  selectedCategory: string | null
}

export class WidgetsModal extends Component<WidgetsModalProps, WidgetsModalState> {
  private readonly isDynamicWidgetModuleEnabled: boolean = common.isModuleActive('dynamicContentWidget')

  state = {
    selectedCategory: null
  }

  render() {
    const { selectedCategory } = this.state
    const { onWidgetSelected, onClose, containerComponent } = this.props
    let availableWidgets = LIBRARY_WIDGETS_METADATA
    if (!this.isDynamicWidgetModuleEnabled) {
      availableWidgets = LIBRARY_WIDGETS_METADATA.filter((widget) => widget.type !== 'dynamic_content')
    }

    return (
      <Modal
        onClose={onClose}
        onBackdropClick={onClose}
        isControl
        isHeightAdjustable={false}
        direction='horizontal'
        disableScrollLock
      >
        <ModalHeader title='Choose a widget' />
        <ModalBody>
          <WidgetCategoryFilter
            selectedCategory={this.state.selectedCategory}
            categories={LIBRARY_WIDGET_CATEGORIES}
            availableWidgets={availableWidgets.filter((widget) => widget.containers.includes(containerComponent))}
            onClick={(category) => this.setState({ selectedCategory: category })}
          />

          <div className='widgets-library--widget-list'>
            {availableWidgets
              .filter((widget) => {
                if (selectedCategory === null) {
                  return true
                }
                return widget.category === selectedCategory
              })
              .map((widget, idx) => (
                <WidgetCard
                  key={widget.title}
                  widget={widget}
                  onWidgetSelected={() => {
                    onWidgetSelected(widget.type)
                    onClose()
                  }}
                  idx={idx}
                  disabled={!widget.containers.includes(containerComponent)}
                />
              ))}
          </div>
        </ModalBody>
      </Modal>
    )
  }
}
